import {
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE
} from "../Constants";

export const ChangePasswordActions = (payload) => ({
    type: CHANGE_PASSWORD,
    payload
});

export const ChangePasswordActionsSuccess = (payload) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload
});

export const ChangePasswordActionsFailure = (payload) => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload
});